import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';
import ColorScale from '_class/ColorScale';
import { getVerdictScale } from 'actions/verdicts';
import '../Verdict.scss';

var VerdictWidget = /*#__PURE__*/function (_Component) {
  _inherits(VerdictWidget, _Component);

  var _super = _createSuper(VerdictWidget);

  function VerdictWidget() {
    var _this;

    _classCallCheck(this, VerdictWidget);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.scale == null) {
        _this.props.getVerdictScale();
      }
    });

    return _this;
  }

  _createClass(VerdictWidget, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.props.scale == null) {
        return null;
      }

      var scale = this.props.scale;
      var verdictColors = new ColorScale(scale.levels.length).get();
      return /*#__PURE__*/React.createElement("div", {
        className: "verdict verdict-widget"
      }, this.props.displayLabel ? /*#__PURE__*/React.createElement("div", {
        className: "level-text"
      }, scale.levels.map(function (cell) {
        if (_this2.props.verdict != null) {
          if (cell.id == _this2.props.verdict.scaleLevelId) {
            return /*#__PURE__*/React.createElement("span", {
              key: 'verdict-widget-text-' + cell.id
            }, cell.shortLocalizationText != null ? cell.shortLocalizationText : cell.level);
          }
        }

        return null;
      })) : null, this.props.displayLevel ? /*#__PURE__*/React.createElement("div", {
        className: "verdict-levels"
      }, scale.levels.map(function (cell) {
        var styles = {};

        if (_this2.props.verdict != null) {
          if (cell.id == _this2.props.verdict.scaleLevelId) {
            styles = {
              backgroundColor: cell.colorCode != null ? cell.colorCode : verdictColors[cell.level]
            };
          }
        }

        return /*#__PURE__*/React.createElement("div", {
          key: 'verdict-widget-cell-' + cell.id,
          style: styles,
          className: "level-dot"
        });
      })) : null);
    }
  }]);

  return VerdictWidget;
}(Component);

_defineProperty(VerdictWidget, "defaultProps", {
  displayLabel: true,
  displayLevel: true
});

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    scale: state.Verdicts.scale
  };
}

export default connect(mapStateToProps, {
  getVerdictScale: getVerdictScale
})(VerdictWidget);